module.exports = __webpack_public_path__ + "img/1025.7c932a21.gif";